import { IHPContact } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

import { getHPContactPhone } from './getHPContactPhone'

export const getHpContactData = (hpContact?: IHPContact) => {
  if (!hpContact) {
    return {}
  }

  const hpContactPhoneData = getHPContactPhone(hpContact)

  return {
    HPContactEmail: hpContact.Email,
    HPContactPhone: hpContactPhoneData.phone,
    HPContactPhoneCode: hpContactPhoneData.code,
  }
}
